import styled, { css } from 'styled-components';

export const PickerWrapper = styled.div`
  display: contents;

  em-emoji-picker {
    --border-radius: 4px;
    --category-icon-size: 32px;
    --color-border-over: ${({ theme }) => theme.colors.iconGray};
    --color-border: ${({ theme }) => `${theme.colors.iconGray}7A`};
    --font-family: 'Open Sans';
    --font-size: 12px;
    --rgb-accent: 0, 133, 255;
    --rgb-background: 255, 255, 255;
    --rgb-color: 160, 175, 190;
    --rgb-input: 255, 255, 255;
    --shadow: ${({ theme }) => theme.boxShadows.bottomLight};

    border: 1px solid ${({ theme }) => theme.colors.separatorOnWhite};
    max-height: 320px;
  }
`;

export const emojiMartOverwrite = css`
  #nav {
    padding-block: 5px;
  }

  #nav .bar {
    bottom: -5px;
    border-radius: 0;
    height: 2px;
  }

  .sticky {
    font-weight: 600;
  }

  .search input[type='search'] {
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #e1e6ea;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    padding: 7px 7px 7px 30px;

    &:focus {
      border-color: #0085ff;
      box-shadow: none;
    }
  }

  svg {
    fill: none;
    font-size: 16px;
  }

  .loupe svg {
    fill: currentColor;
  }
`;

export const overwriteStyles = document.createElement('style');
overwriteStyles.innerHTML = emojiMartOverwrite.toString();
